import { Table } from 'primeng/table';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsService } from 'src/app/core/services/constants.service';
import { UserToken } from 'src/app/core/auth.model';
import { Observable } from 'rxjs';
import { BreadCrumb } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.model';
import * as FileSaver from 'file-saver';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { BreadcrumbService } from 'src/app/layout/topbar/app.breadcrumb.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { WoOrderServiceDefault } from 'src/app/models/response/wo-order-service-default.model';
import { WoOrderServiceDefaultService } from '../wo-order-service-default.service';

@Component({
    selector: 'wo-order-service-default-grid',
    templateUrl: './wo-order-service-default-grid.component.html',
    styleUrls: ['./wo-order-service-default-grid.component.scss'],
    providers: [ConfirmationService, MessageService],
    encapsulation: ViewEncapsulation.None
})
export class WoOrderServiceDefaultGridComponent implements OnInit {

    public user$: Observable<UserToken>;
    public user?: UserToken;
    public list: WoOrderServiceDefault[] = [];
    public item: WoOrderServiceDefault = {};

    public language: string = "pt-BR";
    public pageMessage: string = "";
    public displayDialog: boolean = false;
    public submitted: boolean = false;
    public canUpdate: boolean = false;
    public isLoading: boolean = true;
    public isCartorio: boolean = false;
    public dialogHeader: string = "";

    public classBtnUpd: string = "p-button p-button-success p-m-1 mr-1";
    public classBtnDel: string = "p-button p-button-warning p-m-1 mr-1";
    public showValueB: boolean = false;
    public showTaxA: boolean = true;
    public showTaxB: boolean = false;
    public showRange: boolean = true;
    public labelUnitValueA: string = "";
    public labelUnitValueB: string = "";
    public labelUnitValueTaxA: string = "";
    public labelUnitValueTaxB: string = "";
    public labelUnitValueTaxApp: string = "";
    public labelUnitValueTaxPay: string = "";

    public BREAD_CRUMB_LIST: Array<BreadCrumb> = [
        { label: 'Configuração', routerLink: '/', selected: false },
        { label: 'Serviços Padrão', routerLink: '/wo-order-service-default', selected: true }
    ];

    constructor(
        private orderServiceDefaultService: WoOrderServiceDefaultService,
        private confirmationService: ConfirmationService,
        private constantsService: ConstantsService,
        private messageService: MessageService,
        private translateService: TranslateService,
        private translateConfigService: TranslateConfigService,
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        private userTokenService: UserTokenService
    ) { }

    ngOnInit(): void {
        this.isLoading = true;
        this.language = this.translateConfigService.getLanguage();
        this.user$ = this.userTokenService.getUser();

        this.user$.subscribe({
            next: (data) => { this.user = data; }
        });

        this.isCartorio = true;
        this.canUpdate = this.userTokenService.hasPermissionArray(['SF_ADMIN', 'SF_SELLER', 'ROLE_ADMIN', 'ROLE_MANAGER']);

        this.getList();
        this.translate();

        if (this.canUpdate == false) {
            this.classBtnDel = "p-button p-button-secondary p-m-1 mr-1";
        }
    }

    getList() {
        this.orderServiceDefaultService.getList().subscribe(
            {
                next: (res) => {
                    if (res)
                        this.list = res.data;
                    this.isLoading = false;
                },
                error: (err) => {
                    this.messageError(this.translateService.instant('api_response.ERROR'));
                    console.log(`WoOrderServiceDefaultGrid - getList : ${err}.`);
                }
            });
    }

    addItem() {
        this.item = {};
        this.displayDialog = true;
        this.submitted = false;
    }

    updItem(item: WoOrderServiceDefault) {
        this.item = { ...item };
        this.displayDialog = true;
        this.submitted = false;
    }

    delItem(item: WoOrderServiceDefault) {
        this.confirmationService.confirm({
            message: this.translateService.instant('message.confirm_delete') + ' ' + item.name + '?',
            header: this.translateService.instant('title.confirmation'),
            acceptLabel: this.translateService.instant('button.yes'),
            rejectLabel: this.translateService.instant('button.no'),
            acceptButtonStyleClass: 'p-button-success',
            rejectButtonStyleClass: 'p-button-danger',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.orderServiceDefaultService
                    .delItem(item.id)
                    .subscribe(
                        {
                            next: () => {
                                this.messageSuccess(this.translateService.instant('message.record_deleted'));
                                this.isLoading = true;
                                this.getList();
                            },
                            error: (err) => {
                                this.messageError(this.translateService.instant('api_response.ERROR'));
                                console.log(`WoOrderServiceDefaultGrid - delItem : ${err}.`);
                            }
                        });
            }
        });
    }

    saveItem() {
        this.submitted = true;
        if (this.item.code && this.item.code.trim()) {
            if (this.item.id) {
                this.orderServiceDefaultService
                    .updItem(this.item)
                    .subscribe(
                        {
                            next: () => {
                                this.messageSuccess(this.translateService.instant('message.record_updated'));
                                this.isLoading = true;
                                this.getList();
                            },
                            error: (err) => {
                                this.messageError(this.translateService.instant('api_response.ERROR'));
                                console.log(`WoOrderServiceDefaultGrid - updItem : ${err}.`);
                            }
                        });

            } else {
                this.orderServiceDefaultService
                    .addItem(this.item)
                    .subscribe(
                        {
                            next: () => {
                                this.messageSuccess(this.translateService.instant('message.record_inserted'));
                                this.isLoading = true;
                                this.getList();
                            },
                            error: (err) => {
                                this.messageError(this.translateService.instant('api_response.ERROR'));
                                console.log(`WoOrderServiceDefaultGrid - addItem : ${err}.`);
                            }
                        });
            }

            this.list = [...this.list]
            this.displayDialog = false;
            this.submitted = false;
            this.item = {};
        }
    }

    hideDialog() {
        this.displayDialog = false;
        this.submitted = false;
    }

    translate() {
        const sleep = (ms) => new Promise(r => setTimeout(r, ms));

        (async () => {
            await sleep(100);
            const labA = this.translateService.instant('label.services') + " ";
            const labB = " " + this.translateService.instant('label.serviceDefault');
            this.breadcrumbService.setItems([{ label: labA }, { label: labB, routerLink: ['wo-order-service-default'] }]);
            this.pageMessage = this.translateService.instant('grid.showing') + " {first} " + this.translateService.instant('grid.to') + " {last} " + this.translateService.instant('grid.of') + " {totalRecords} " + this.translateService.instant('grid.entries');
            this.dialogHeader = this.translateService.instant('title.woOrderServiceDefaultEdit');

            if (this.isCartorio) {
                this.showValueB = this.showTaxA = this.showTaxB = this.showRange = true;
                this.labelUnitValueA = "Recompe";
                this.labelUnitValueB = "Emolumentos";
                this.labelUnitValueTaxA = "Fiscalização";
                this.labelUnitValueTaxB = "ISS";
                this.labelUnitValueTaxApp = "Taxa App";
                this.labelUnitValueTaxPay = "Taxa Pay";
            }
            else {
                this.showValueB = (this.user.ScCompanyConfig.includes("UNIT_VALUE_B"));
                this.showTaxA = (this.user.ScCompanyConfig.includes("UNIT_VALUE_TAX_A"));
                this.showTaxB = (this.user.ScCompanyConfig.includes("UNIT_VALUE_TAX_B"));
                this.showRange = (this.user.ScCompanyConfig.includes("RANGE_VALUE"));

                this.labelUnitValueA = this.translateService.instant('label.unitValue');
                this.labelUnitValueB = this.translateService.instant('label.unitValueAux');
                this.labelUnitValueTaxA = this.translateService.instant('label.unitTaxValue');
                this.labelUnitValueTaxB = this.translateService.instant('label.unitTaxValueAux');
                this.labelUnitValueTaxApp = this.translateService.instant('label.unitTaxApp');
                this.labelUnitValueTaxPay = this.translateService.instant('label.unitTaxPay');
            }
        })();
    }

    clear(table: Table, filter: any) {
        table.clear();
        filter.value = "";
    }

    messageSuccess(message: string) {
        this.messageService.add({ severity: this.constantsService.SEVERITY_SUCCESS, summary: this.translateService.instant('title.success'), detail: this.translateService.instant(message), life: 3000 });
    }

    messageError(message: string) {
        this.messageService.add({ severity: this.constantsService.SEVERITY_WARNING, summary: this.translateService.instant('title.error'), detail: this.translateService.instant(message), life: 3000 });
    }

    exportItem() {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(this.list);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, 'servicos-padrao');
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
}

